<template>
    <div>
      <template v-if="getLawlexLoadingStatus">
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
      </template>
      <template v-else>
        <template v-if="hasErrorCode">
            <UserNotRegistered :type="accessType"/>
        </template>
        <template v-else-if="accordionData && accordionData.length > 0">
            <div class="lawlex-accordion-container">
                    <div class="compact-content-container-wrapper">
                    <div
                    v-for="(item, index) in getLimitedContent(content.title, accordionData)"
                    :key="item.targetUrl || index"
                    class="compact-content-container"
                    >
                        <div v-if="item && item.title">
                            <span class="title-container">
                              <img :src="getImageSrc()"/>
                              <a href="javascript:void(0)" @click="clickUrl(item.targetUrl)">{{ truncateEnd(item.title) }}</a>
                            </span>
                            <span class="date">{{ item.date }}</span>
                        </div>
                    </div>
                    <!-- See More Link -->
                    <a href="javascript:void(0)" @click="clickUrl(seeMoreUrl)" class="see-more">
                        See more
                    </a>
                </div>
            </div>
        </template>
        <template v-else-if="noAccessCondition">
          <NoAccess :type="accessType" />
        </template>
        <template v-else-if="hasErrorCodeUserNotActive">
          <NoDataOrUserNotActive
          :isUserNotActive="true"
          :title="$t('msg_user_not_active')"
          :imageSrc="require('@/img/lawlex-user-icon.svg')"
        />
        </template>
        <template v-else-if="hasErrorCodeTypeOtherErrors">
          <SomethingWentWrong />
        </template>
        <template v-else>
          <NoDataOrUserNotActive
          :isUserNotActive="false"
          :title="noDataMessage"
          :imageSrc="require('@/img/lawlex-no-data.svg')"
        />
        </template>
    </template>
  </div>
</template>


  <script>
  import UserNotRegistered from "@/components/QuickViews/AccordionContent/Lawlex/UserNotRegistered";
  import NoAccess from "@/components/QuickViews/AccordionContent/Lawlex/NoAccess.vue";
  import SomethingWentWrong from "@/components/QuickViews/AccordionContent/Lawlex/SomethingWentWrong.vue";
  import NoDataOrUserNotActive from "@/components/QuickViews/AccordionContent/Lawlex/NoDataOrUserNotActive";
  import { createNamespacedHelpers } from "vuex";
  import i18n from "@/plugins/i18n";

  const { mapActions, mapGetters } = createNamespacedHelpers('quickviews');
  const LAWLEX_TITLES = {
    RECENT_SEARCHES: i18n.t('home_legislation_lawlexau_recent_search'),
    REGULATORY_NEWSFEEDS: i18n.t('home_legislation_lawlexau_reg_newsfeeds'),
    SAVED_SEARCHES: i18n.t('home_legislation_lawlexeu_saved_search'),
  };

  export default {
    name: "LawlexAccordion",
    components: {
        UserNotRegistered,
        NoAccess,
        SomethingWentWrong,
        NoDataOrUserNotActive
    },
    props: {
      content: { type: Object, required: true },
    },
    computed: {
      ...mapGetters([
        'getLawlexRecentSearches',
        'getLawlexNewsfeeds',
        'getLawlexLoadingStatus',
        'getEurlexSavedSearches',
      ]),
      accordionData() {
        if (this.content.title === LAWLEX_TITLES.RECENT_SEARCHES) {
          return this.getLawlexRecentSearches.data;
        } else if (this.content.title === LAWLEX_TITLES.REGULATORY_NEWSFEEDS) {
          return this.getLawlexNewsfeeds.data;
        } else if (this.content.title === LAWLEX_TITLES.SAVED_SEARCHES) {
          return this.getEurlexSavedSearches.data;
        }
        return [];
      },
      seeMoreUrl() {
        if (this.content.title === LAWLEX_TITLES.RECENT_SEARCHES) {
        return this.getLawlexRecentSearches.seeMoreLink || '';
        } else if (this.content.title === LAWLEX_TITLES.REGULATORY_NEWSFEEDS) {
        return this.getLawlexNewsfeeds.seeMoreLink || '';
        } else if (this.content.title === LAWLEX_TITLES.SAVED_SEARCHES) {
        return this.getEurlexSavedSearches.seeMoreLink || '';
        }
        return '';
      },
      hasErrorCode() {
        if (this.content.title === LAWLEX_TITLES.RECENT_SEARCHES) {
            return this.getLawlexRecentSearches?.errorCode == 1;
        } else if (this.content.title === LAWLEX_TITLES.REGULATORY_NEWSFEEDS) {
            return this.getLawlexNewsfeeds?.errorCode == 1;
        } else if (this.content.title === LAWLEX_TITLES.SAVED_SEARCHES) {
            return this.getEurlexSavedSearches?.errorCode == 1;
        }
        return false;
      },
      hasErrorCodeUserNotActive() {
        if (this.content.title === LAWLEX_TITLES.RECENT_SEARCHES) {
            return this.getLawlexRecentSearches?.errorCode == 3;
        } else if (this.content.title === LAWLEX_TITLES.REGULATORY_NEWSFEEDS) {
            return this.getLawlexNewsfeeds?.errorCode == 3;
        }
        return false;
      },
      hasErrorCodeTypeOtherErrors() {
        if (this.content.title === LAWLEX_TITLES.RECENT_SEARCHES) {
          return this.getLawlexRecentSearches?.errorCode == 2;
        } else if( this.content.title === LAWLEX_TITLES.REGULATORY_NEWSFEEDS) {
          return this.getLawlexNewsfeeds?.errorCode == 2;
        }
        return false;
      },
      noAccessCondition() {
        const isRegulatoryNewsfeedsBlocked = this.content.title === LAWLEX_TITLES.REGULATORY_NEWSFEEDS &&
          this.getLawlexNewsfeeds?.hasRegulatoryNewsFeed === false;

        const isRecentSearchesBlocked = this.content.title === LAWLEX_TITLES.RECENT_SEARCHES &&
          this.getLawlexRecentSearches?.hasRecentSearch === false;

        const isSavedSearchBlocked = this.content.title === LAWLEX_TITLES.SAVED_SEARCHES &&
          this.getEurlexSavedSearches?.hasLawlexEUSavedSearch === false;

        return isRegulatoryNewsfeedsBlocked || isRecentSearchesBlocked || isSavedSearchBlocked;

      },
      lawlexTitles() {
        return LAWLEX_TITLES;
      },
      lawlexNoDataMessages() {
        return {
          RECENT_SEARCHES: this.$t('home_leg_recent_search_no_data'),
          REGULATORY_NEWSFEEDS: this.$t('home_leg_reg_newsfeeds_no_data'),
          SAVED_SEARCHES: this.$t('home_legislation_lawlexeu_no_data'),
        };
      },
      noDataMessage() {
        const messages = this.lawlexNoDataMessages;
        const title = this.content.title;

        if (title === this.lawlexTitles.RECENT_SEARCHES) {
          return messages.RECENT_SEARCHES;
        } else if (title === this.lawlexTitles.REGULATORY_NEWSFEEDS) {
          return messages.REGULATORY_NEWSFEEDS;
        } else if (title === this.lawlexTitles.SAVED_SEARCHES) {
          return messages.SAVED_SEARCHES;
        }

        return '';
      },
      accessType() {
        switch (this.content.title) {
          case this.lawlexTitles.RECENT_SEARCHES:
            return 'recent_search';
          case this.lawlexTitles.SAVED_SEARCHES:
            return 'saved_search';
          case this.lawlexTitles.REGULATORY_NEWSFEEDS:
          default:
            return 'regulatory';
        }
      }
    },
    methods: {
      ...mapActions([
        'fetchLawlexAccordions',
        'redirectToUrl'
      ]),
      getLimitedContent(title, content) {
        if (
          [LAWLEX_TITLES.RECENT_SEARCHES, LAWLEX_TITLES.REGULATORY_NEWSFEEDS, LAWLEX_TITLES.SAVED_SEARCHES].includes(title) &&
            content.length > 7
        ) {
            return content.slice(0, 7).concat([{}]);
        }
            return content;
        },
        truncateEnd(str, maxLength = 35) {
          if (!str || str.length <= maxLength) return str;
          return str.slice(0, maxLength - 3) + '...';
        },
        clickUrl(url) {
            if (!url) {
              console.error("No URL provided for this item.");
              return;
            }
            const module = `Dashboard - ${this.$t(this.content.title)}`;
            const type = this.content.title === LAWLEX_TITLES.SAVED_SEARCHES ? 'lawlexeu' : 'lawlexau';
            this.redirectToUrl({ url, module, type });
        },
        getImageSrc() {
          if (this.content.title === this.lawlexTitles.RECENT_SEARCHES) {
            return require('@/img/lawlex-recent-search-icon.svg');
          } else if (this.content.title === this.lawlexTitles.REGULATORY_NEWSFEEDS) {
            return require('@/img/lawlex-regulatory-icon.svg');
          } else if (this.content.title === this.lawlexTitles.SAVED_SEARCHES) {
            return require('@/img/eurlex-saved-search-icon.svg');
          }
        },
    },
    mounted() {
      let fetchType = '';
      if (this.content.title === LAWLEX_TITLES.RECENT_SEARCHES) {
        fetchType = 'recentSearches';
      } else if (this.content.title === LAWLEX_TITLES.REGULATORY_NEWSFEEDS) {
        fetchType = 'newsFeeds';
      } else if (this.content.title === LAWLEX_TITLES.SAVED_SEARCHES) {
        fetchType = 'savedSearches';
      }
      this.fetchLawlexAccordions({ fetchType });
    },
  };
  </script>

